import React, { PureComponent }  from 'react';
import { connect } from 'react-redux';
import _compact from "lodash/compact";

class  WhyBusabout extends PureComponent{

  renderMustSees(props){
    const _mustSees = _compact(props.split("- __"));
    const _mustSeesMod = _mustSees.map(item => item.replace('__', ' -'));
    return _mustSeesMod
  }

  render(){

    const { itineraries:{content:{bucket_list} } } = this.props;

    return (
      <div className="cyao-whybusabout" id="cyao-whybusabout">
        <div className="row">
          <div className="column small-12 large-11 large-offset-0-5">
            <div className="row">
              <div className="column small-12">
                <h3 className="busabout-h3 uppercase">Why Busabout trips are epic</h3>
                <p className="no-margin">Here are some of the benefits of travelling with Busabout.</p>
                <p className="no-margin">All our customers get amazing discounts at many of out optional activites.</p>
              </div>
            </div>

            <div className="row margin-t-50">
              <div className="column small-12 medium-6 large-5">

                <div className="row">
                  <div className="column small-3 large-2">
                    <svg width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                      <g fill="#F60" fillRule="evenodd">
                        <circle fillOpacity=".2" cx="32" cy="32" r="32"/>
                        <g fillRule="nonzero">
                          <path d="M32 44c-3 0-6.2-.2-9.2-.6a3.1 3.1 0 0 1-2.8-3V23.2c0-4 3.3-7.2 7.4-7.2h9.2c4 0 7.4 3.2 7.4 7.2v17.2c0 1.5-1.2 2.8-2.8 3-3 .4-6.1.6-9.2.6zm-4.6-26.3a5.6 5.6 0 0 0-5.7 5.5v17.2c0 .7.5 1.3 1.3 1.4a76.8 76.8 0 0 0 18 0c.8 0 1.3-.7 1.3-1.4V23.2c0-3-2.6-5.5-5.7-5.5h-9.2z"/>
                          <path d="M20.9 23c-.5 0-.9-.4-.9-1 0-.5.4-1 .9-1H43c.5 0 .9.4.9 1 0 .5-.4 1-.9 1H21zM43.1 34H21c-.5 0-.9-.4-.9-1s.4-1 .9-1H43c.5 0 .9.4.9 1s-.4 1-.9 1zM27.8 48h-1.6C25 48 24 47 24 45.6v-2.7c0-.2.1-.5.3-.7l.6-.2 4.3.4c.5 0 .8.4.8 1v2.2c0 1.3-1 2.4-2.2 2.4zm-2.1-4v1.6c0 .3.2.6.5.6h1.6c.3 0 .5-.3.5-.6v-1.4l-2.6-.3zM38.8 48h-1.6C36 48 35 47 35 45.6v-2.2c0-.5.3-.9.8-1L40 42c.2 0 .4 0 .6.2.2.2.3.4.3.7v2.7c0 1.3-1 2.4-2.2 2.4zm-2.1-3.8v1.4c0 .3.2.6.5.6h1.6c.3 0 .5-.3.5-.6V44l-2.6.3zM35.1 38H29c-.5 0-.9-.4-.9-1s.4-1 .9-1H35c.5 0 .9.4.9 1s-.4 1-.9 1zM35.1 40H29c-.5 0-.9-.4-.9-1s.4-1 .9-1H35c.5 0 .9.4.9 1s-.4 1-.9 1zM35.1 21H29c-.5 0-.9-.4-.9-1s.4-1 .9-1H35c.5 0 .9.4.9 1s-.4 1-.9 1z"/>
                          <path d="M47.2 25c-.5 0-.9-.3-.9-.8 0-.4-.3-.8-.6-1-1.1-.8-2.7-.6-2.7-.6-.5 0-1-.3-1-.7 0-.4.3-.8.7-.9.1 0 2.3-.2 4 .9a3 3 0 0 1 1.3 2.3c0 .5-.4.8-.8.8z"/>
                          <path d="M47.1 30h-1C45 30 44 29 44 27.9v-3c0-.5.4-.9.9-.9H47c.5 0 .9.4.9.9V29c0 .5-.4.9-.9.9zm-1.4-4.2v2c0 .3.2.4.4.4h.2v-2.4h-.6zM16.8 25c-.4 0-.8-.3-.8-.8a3 3 0 0 1 1.3-2.3 6.4 6.4 0 0 1 4-.9c.4 0 .8.5.7.9 0 .4-.5.7-1 .7 0 0-1.6-.2-2.7.5-.3.3-.6.7-.6 1.1 0 .5-.4.8-.9.8z"/>
                          <path d="M17.9 30h-1a.9.9 0 0 1-.9-.9V25c0-.5.4-.9.9-.9H19c.5 0 .9.4.9.9v3c0 1.1-1 2.1-2.1 2.1zm-.2-1.8h.2c.2 0 .4-.1.4-.3v-2.1h-.6v2.4zM23.9 40h-3c-.5 0-.9-.4-.9-.8v-3.4c0-.4.4-.8.9-.8h3c1.2 0 2.1.9 2.1 2v1c0 1.1-1 2-2.1 2zm-2.1-1.7h2.1c.2 0 .3-.1.3-.3v-1c0-.2-.1-.3-.3-.3h-2.1v1.6zM43.1 40h-3c-1.2 0-2.1-.9-2.1-2v-1c0-1.1 1-2 2.1-2h3c.5 0 .9.4.9.8v3.4c0 .2 0 .4-.3.6a1 1 0 0 1-.6.2zm-3-3.3c-.2 0-.3.1-.3.3v1c0 .2.1.3.3.3h2.1v-1.6h-2.1zM37.8 30a.8.8 0 1 1 0-1.6h1.6v-1.6a.8.8 0 0 1 1.6 0v2.4c0 .4-.3.8-.8.8h-2.4z"/>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className="column small-9 large-10">
                    <p className="title no-margin">Trip Highlights</p>
                    <p className="subtitle">Include with your trip</p>
                  </div>
                </div>


                <ul className="highlights">
                  <li>Our trips are expertly guided by our friendly and knowledgeable crew.</li>
                  <li>Modern coaches with door-to-door service to our pick-up and drop-off points.</li>
                  <li>Get access to out onboard entertainment for great movies, city guides and much more.</li>
                  <li>Choose from a wide range of optional activities with the help of our guides and book at a discounted Busabout rate.</li>
                </ul>
              </div>
              <div className="column small-12 medium-6 large-5">

                <div className="row">
                  <div className="column small-3 large-2">
                    <svg width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                      <g fill="#3ABCCB" fillRule="evenodd">
                        <circle fillOpacity=".2" cx="32" cy="32" r="32"/>
                        <g fillRule="nonzero">
                          <path d="M45.2 33.8c-.2 0-.4 0-.5-.2l-1.8-1.8a.8.8 0 0 1 1.1-1l1.2 1.1 1.2-1.2a.8.8 0 0 1 1.2 1.1l-1.8 1.8c-.2.2-.4.2-.6.2zM31 39.2a6.1 6.1 0 1 1 0-12.3 6.1 6.1 0 0 1 0 12.3zm0-10.7a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z"/>
                          <path d="M31 36.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm0-5.3a1.9 1.9 0 1 0 0 3.7 1.9 1.9 0 0 0 0-3.7zM24.8 25h-4.2a.8.8 0 0 1-.8-.8v-1.5c0-1 .7-1.7 1.7-1.7H24c.8 0 1.5.7 1.5 1.6v1.6c0 .4-.3.8-.8.8zm-3.4-1.6H24v-.8h-2.7v.8z"/>
                          <path d="M42.5 42.7h-23c-2 0-3.5-1.5-3.5-3.5V27c0-2 1.6-3.5 3.5-3.5h23c2 0 3.5 1.5 3.5 3.5v2a.8.8 0 0 1-1.6 0v-2c0-1-.8-2-1.9-2h-23c-1 0-2 1-2 2v12.3c0 1 1 2 2 2h23c1 0 2-1 2-2V36a.8.8 0 0 1 1.5 0v3.2c0 2-1.5 3.5-3.5 3.5z"/>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className="column small-9 large-10">
                    <p className="title no-margin">There are <strong className="orange-text">{bucket_list.data_count} Travel bucket items</strong> to tick off your list on this trip. Here are some of them.</p>
                    <p className="subtitle"></p>
                  </div>
                </div>

                <ul className="bucket-list">
                  {
                    this.renderMustSees(bucket_list.list).map((item, i) => { return <li key={i}>{item}</li> })
                  }
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }

}


function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data
  }
}

export default connect(mapStateToProps, null)(WhyBusabout);



// WEBPACK FOOTER //
// ./src/components/itinerary/components/why-busabout.js